import React, { useEffect, useState } from 'react';
import Table from '../../../../../Utils/Grid';
import { standardActions } from '../../../../../Utils/Grid/StandardActions';
import TitleUnderline from '../../../../../Utils/TitleUnderline';
import KitExpandTable from './KitExpandTable';
import dayjs from 'dayjs';
import TitleSubTitle from '../../../Utils/TitleSubTitle';

const data = {
    count: 3,
    next: null,
    previous: null,
    results: [],
};

const DetailTable = ({ issueData, isViewed, issues, setIssues }) => {
    const [issueViewed, setIssueViewed] = useState({
        date_issue: '',
        origin: '',
    });
    // Allow row expand
    const [openExpand, setOpenExpand] = useState(false);
    // set issues to results
    data.results = issues;

    if (isViewed) {
        useEffect(() => {
            if (issueData.origin) {
                const date_issue = dayjs(issueData.date).format('YYYY-MM-DD');
                setIssueViewed({
                    date_issue,
                    origin: issueData.origin.name,
                });
            }
        }, [issueData]);
    }

    // Get input changes
    const changeData = (dataObj, e) => {
        const changedFormValues = {
            ...dataObj,
            [e.target.name]: e.target.value,
        };
        return changedFormValues;
    };

    // Set input changes to issues
    const handleChange = (id, e) => {
        const changedIssue = issues.map((issue) => {
            return issue.id === id ? changeData(issue, e) : issue;
        });
        setIssues(changedIssue);
    };

    // Allow row expand
    const options = {
        onRowClick: (row, i) => {
            // if the row product was clicked
            if (i === 1) {
                // Expand row
                setOpenExpand(true);
            } else {
                setOpenExpand(false);
            }
        },
    };
    const format = (cell) => {
        if (cell === 'NO_SERIAL' || cell === '' || cell === undefined) {
            return '---';
        }
        return cell;
    };
    const formatText = (cell) => {
        if (cell === '' || !cell) {
            return '---';
        }
        return cell;
    };
    return (
        <React.Fragment>
            {isViewed && (
                <div className="d-flex flex-md-row flex-column flex-wrap mb-3">
                    <TitleSubTitle
                        title="Ubicación"
                        subTitle={issueViewed.origin}
                    />
                    <TitleSubTitle
                        title="Fecha de salida"
                        subTitle={issueViewed.date_issue}
                    />
                </div>
            )}
            <TitleUnderline title="Detalle de salida" className="mt-4" />
            <Table
                className="mt-2"
                data={data}
                expandableRow={(row) => {
                    // if it is a school kit, show expand row
                    if (row.product.school_kit && openExpand) return true;
                    return false;
                }}
                expandComponent={(row) => {
                    // formatted data for table and display table
                    const school_kit = row.product.school_kit;
                    const products = school_kit.map((kit) => {
                        const { quantity, product } = kit;
                        const { code, description, category, sub_location } = product;
                        const total_quantity = quantity * row.quantity;
                        return {
                            code,
                            description,
                            category,
                            quantity,
                            total_quantity,
                            sub_location,
                        };
                    });

                    // Return the table of products, with the formatted data
                    return <KitExpandTable products={products} />;
                }}
                options={options}
                // onPageChange={(page) => getData(page)}
                // page={page}
                // loading={loader}
            >
                {!isViewed && (
                    <TableHeaderColumn
                        dataField="id"
                        dataAlign="center"
                        isKey
                        width="5rem"
                        dataFormat={standardActions({
                            erase: (id) => {
                                const changedIssue = issues.filter(
                                    (issue) => issue.id !== id
                                );
                                setIssues(changedIssue);
                            },
                        })}
                    ></TableHeaderColumn>
                )}
                <TableHeaderColumn
                    className="mt-5"
                    width="12rem"
                    isKey={isViewed}
                    dataField="description"
                >
                    Artículo
                </TableHeaderColumn>
                <TableHeaderColumn width="7rem" dataField="quantity">
                    Cantidad
                </TableHeaderColumn>
                {/* <TableHeaderColumn width="10rem" dataField="location_name">
                    Ubicación salida
                </TableHeaderColumn> */}
                <TableHeaderColumn
                    width="10rem"
                    dataField="serial_number"
                    dataFormat={format}
                >
                    Serie
                </TableHeaderColumn>
                <TableHeaderColumn
                    width="10rem"
                    dataField="sub_location"
                    dataFormat={(value, data) => {
                        const { id } = data;
                        if (!isViewed) {
                            return (
                                <input
                                    className="form-control w-100"
                                    placeholder="Ingrese la sub Ubicacion"
                                    name="sub_location"
                                    onChange={(e) => handleChange(id, e)}
                                    value={value}
                                    onClick={() => setOpenExpand(false)}
                                />
                            );
                        }
                        return value ? value : '---';
                    }}
                >
                    Sub Location
                </TableHeaderColumn>
                <TableHeaderColumn
                    width="10rem"
                    dataField="observations"
                    dataFormat={(value, data) => {
                        const { id } = data;
                        if (!isViewed) {
                            return (
                                <input
                                    className="form-control w-100"
                                    placeholder="Ingrese Observacion"
                                    name="observations"
                                    onChange={(e) => handleChange(id, e)}
                                    value={value}
                                    onClick={() => setOpenExpand(false)}
                                />
                            );
                        }
                        return value ? value : '---';
                    }}
                >
                    Observacion
                </TableHeaderColumn>
                {isViewed && (
                    <TableHeaderColumn
                        width="7rem"
                        dataField="school_kit_name"
                        dataFormat={formatText}
                    >
                        Kit escolar
                    </TableHeaderColumn>
                )}
            </Table>
        </React.Fragment>
    );
};

export default DetailTable;
